module.exports = __webpack_public_path__ + "img/new-step7.1aa0468b.jpg";